import { render, staticRenderFns } from "./DraggableList.vue?vue&type=template&id=3ecb058d&"
import script from "./DraggableList.vue?vue&type=script&lang=js&"
export * from "./DraggableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports